import React, { useState, useMemo, useEffect } from 'react';
import { Button, TextField, Card, View, Text } from '@aws-amplify/ui-react';
import { useTable, usePagination, useGlobalFilter } from 'react-table';

const AsinTableModal = ({ asinData, onSelectASIN  }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [filteredData, setFilteredData] = useState(asinData);
  const [selectedASIN, setSelectedASIN] = useState('');

  // Update filtered data whenever search query changes
  useEffect(() => {
    if (searchQuery === '') {
      setFilteredData(asinData);
    } else {
      setFilteredData(
        asinData.filter(item => item.asin.includes(searchQuery) || item.sku.includes(searchQuery))
      );
    }
  }, [searchQuery, asinData]);

  // Memoize table data for react-table
  const data = useMemo(() => filteredData, [filteredData]);

  // Define columns for react-table
  const columns = useMemo(
    () => [
      {
        Header: 'ASIN',
        accessor: 'asin',
      },
      {
        Header: 'SKU',
        accessor: 'sku',
      },
      {
        Header: 'Available Quantity',
        accessor: 'availableQuantity',
      },
      {
        Header: 'Action',
        accessor: 'selectASIN',
        Cell: ({ row }) => (
          <Button
            onClick={() => {
                onSelectASIN(row.original.asin);
                setSelectedASIN(row.original.asin)
              setIsModalOpen(false);
            }}
          >
            Select ASIN
          </Button>
        ),
      },
    ],
    []
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state
  } = useTable(
    {
      columns,
      data,
      initialState: {
        pageIndex: 0,
        pageSize: 10, // Set page size
      },
    },
    useGlobalFilter, // Use global search filter
    usePagination // Enable pagination
  );

  const { pageIndex, pageSize } = state; 

  // Handle search query changes
  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  return (
    <div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <span style={{ fontWeight: 'normal' }}>{selectedASIN || 'No ASIN selected yet'}</span>
            <Button onClick={() => setIsModalOpen(true)}>Select ASIN </Button>
        </div>


      {isModalOpen && (
        <View
          style={{
            position: 'fixed',
            top: '0',
            left: '0',
            right: '0',
            bottom: '0',
            backgroundColor: 'rgba(0,0,0,0.5)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 1000,
          }}
          onClick={(e) => e.stopPropagation()} 
        >
          <Card
            style={{
              width: '80%',
              padding: '20px',
              maxHeight: '80vh',
              overflowY: 'auto',
              backgroundColor: 'white',
              boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <TextField
              label="Search ASIN or SKU"
              value={searchQuery}
              onChange={handleSearchChange}
              placeholder="Search by ASIN or SKU"
            />

            {/* Table component */}
            <table {...getTableProps()} style={{ width: '100%', marginTop: '20px', borderCollapse: 'collapse' }}>
              <thead>
                {headerGroups.map(headerGroup => (
                  <tr {...headerGroup.getHeaderGroupProps()}>
                    {headerGroup.headers.map(column => (
                      <th {...column.getHeaderProps()} style={{ padding: '10px', textAlign: 'left', borderBottom: '2px solid #ddd' }}>
                        {column.render('Header')}
                      </th>
                    ))}
                  </tr>
                ))}
              </thead>
              <tbody {...getTableBodyProps()}>
                {page.map(row => {  
                    prepareRow(row);
                    return (
                    <tr {...row.getRowProps()}>
                        {row.cells.map(cell => (
                        <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                        ))}
                    </tr>
                    );
                })}
                </tbody>
            </table>

            {/* Pagination controls */}
            <div style={{ marginTop: '20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Button onClick={() => previousPage()} disabled={!canPreviousPage}>
                    Previous
                </Button>

                <span>
                    Page {pageIndex + 1} of {pageOptions.length > 0 ? pageOptions.length : 1}
                </span>

                <Button onClick={() => nextPage()} disabled={!canNextPage}>
                    Next
                </Button>

                {/* Page size selection */}
                <select
                value={pageSize}
                onChange={(e) => setPageSize(Number(e.target.value))}
                style={{ marginLeft: '10px', padding: '5px' }}
                >
                <option value={10}>10</option>
                <option value={20}>20</option>
                <option value={50}>50</option>
                <option value={100}>100</option>
                </select>
            </div>

            <Button onClick={() => setIsModalOpen(false)} style={{ marginTop: '20px' }}>
              Close
            </Button>
          </Card>
        </View>
      )}
    </div>
  );
};

export default AsinTableModal;
